import React from 'react';

const whyChooseWebDevFeatures = [
  {
    id: 'visual-design',
    title: 'Visual Design',
    desc: 'The visual design team at our company is essential in determining how consumers see your brand on the internet. Our designers put more effort into making user interfaces that are pleasing to the eye, intuitive, and in line with your company’s objectives. We have noticed that user involvement and the length of time visitors spend on your website are strongly impacted by well-designed content.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19l7-7 3 3-7 7-3-3z" />
        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
        <path d="M2 2l7.586 7.586" />
        <circle cx="11" cy="11" r="2" />
      </svg>
    )
  },
  {
    id: 'client-engagement',
    title: 'Client Engagement',
    desc: 'We consider that clear and the same client input is critical to effective project execution. From the basic to the final giving, our team’s strategy is made to keep you active, involved, and bold at all stages of the design. We will offer updates from time to time, share progress reports, and take input to ensure that your expectations are met throughout the project.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <circle cx="9" cy="10" r="1.5" fill="currentColor" />
        <circle cx="15" cy="10" r="1.5" fill="currentColor" />
      </svg>
    )
  },
  {
    id: 'on-time-delivery',
    title: 'On Time Delivery',
    desc: 'We realize how important time frames are. Businesses base on timely launches to keep up with marketing strategies, product rollouts, and consumer expectations. We prioritize delivery on time for all web development projects. Our team follows a deeply defined project plan that includes milestones and deadlines.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="3" />
        <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="3" />
        <circle cx="9" cy="10" r="1" fill="currentColor" />
        <circle cx="12" cy="10" r="1" fill="currentColor" />
        <circle cx="15" cy="10" r="1" fill="currentColor" />
        <circle cx="9" cy="13" r="1" fill="currentColor" />
        <circle cx="12" cy="13" r="1" fill="currentColor" />
        <circle cx="15" cy="13" r="1" fill="currentColor" />
      </svg>
    )
  },
  {
    id: 'technical-expertise',
    title: 'Technical Expertise',
    desc: 'We, and our team of experts, have a strong technical understanding of a variety of development architectures and technologies. We create websites that perform well, load quickly, and adhere to current industry standards, from front-end design to back-end programming.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        <polyline points="10 13 8 15 10 17" />
        <polyline points="14 13 16 15 14 17" />
      </svg>
    )
  },
  {
    id: 'client-driven-approach',
    title: 'Client Driven Approach',
    desc: 'Every action we take is guided by your business goals. We use a strategy driven by clients to make sure that every project is designed according to your requirements, not just for our convenience. From the basic discovery meeting to the final delivery, your review helps develop the website’s style, structure, and functionalities.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="12" y1="9" x2="12" y2="21" />
        <circle cx="7.5" cy="13.5" r="1.5" />
        <circle cx="16.5" cy="13.5" r="1.5" />
        <circle cx="7.5" cy="18" r="1.5" />
        <circle cx="16.5" cy="18" r="1.5" />
      </svg>
    )
  },
  {
    id: 'ongoing-support',
    title: 'Ongoing Support',
    desc: 'We do more than just build websites; we also support you after they are launched. Our continued support maintains that your website continues to run properly, is secure, and meets the newest requirements. Businesses depend on us for consistent maintenance that helps prevent problems before they affect users. Our service includes technical monitoring, regular upgrades, problem repairs, and performance ratings.',
    icon: (
      <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  }
];

function WhyChooseWebDevelopment() {
  const handleCtaClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdev-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="why-choose-webdev-section">
      <div className="container">
        {/* Section Header */}
        <div className="why-choose-ecom-header">
          <div className="why-choose-ecom-badge-row">
            <span className="why-choose-ecom-badge">Why Choose Us</span>
            <div className="why-choose-ecom-badge-line"></div>
          </div>

          <h2 className="why-choose-ecom-title">
            Why Choose Our <span className="text-red">Web Development</span> Services?
          </h2>

          <p className="why-choose-ecom-subtitle">
            We merge technical mastery with client-centric strategy to engineer high-performing, secure, and scalable websites that drive business growth.
          </p>
        </div>

        {/* 6 Red Feature Cards Grid */}
        <div className="why-choose-webdev-grid">
          {whyChooseWebDevFeatures.map((item) => (
            <div key={item.id} className="why-choose-webdev-card" onClick={handleCtaClick}>
              {/* Top Rounded Header Box */}
              <div className="why-choose-webdev-box">
                <div className="why-choose-webdev-icon">
                  {item.icon}
                </div>
                <h3 className="why-choose-webdev-box-title">{item.title}</h3>
              </div>

              {/* Description Body */}
              <p className="why-choose-webdev-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseWebDevelopment;
